<template>
  <Card :title="t('email.form.title')">
    <form class="form" novalidate @submit.prevent="handleSubmit">
        <FormInput ref="newEmailInput" name="email" type="email"
                    v-model="newEmail" 
                    :label="t('email.form.label')"
                    :placeholder="currentEmail" 
                    :rules="[mustMatchEmailFormat]"
                    @validated="handleValidation"/>
      <FormTooltip>
        <p v-html="t('email.form.warning')"></p>
      </FormTooltip>
      <button class="form__submit btn btn--fullscreen">{{ t('global.save') }}</button>
    </form>
  </Card>
</template>

<script lang="ts" setup>
import {computed, ref} from "vue"
import {mustMatchEmailFormat} from "@/validation/rules"

import Card from "@/components/layout/Card.vue"
import FormInput from "@/components/forms/FormInput.vue"
import FormTooltip from "@/components/forms/FormTooltip.vue";

import {useI18n} from "vue3-i18n"
import {useUserService} from "@/inversify.config"
import {useMemberStore} from "@/stores/memberStore"

import {SucceededOrNotResponse} from "@/types/responses/succeededOrNotResponse"
import {IChangeEmailRequest} from "@/types/requests/changeEmailRequest"
import {Status} from "@/validation";
import { notifyError, notifySuccess } from "@/notify";

const {t} = useI18n()
const memberStore = useMemberStore()
const userService = useUserService()

const newEmail = ref<string>("")
const newEmailInput = ref<typeof FormInput>()

const currentEmail = computed(() => memberStore.getMember.email)

const changeEmailResponse = ref<SucceededOrNotResponse>()

const inputValidationStatuses:any = {};
async function handleValidation(name: string, validationStatus: Status) {
  inputValidationStatuses[name] = validationStatus.valid
}

async function showErrorMessages() {
  newEmailInput.value?.validateInput(newEmail.value);
}

async function handleSubmit() {
  showErrorMessages();

  if (Object.values(inputValidationStatuses).some(x => x === false)) {
    notifyError(t('global.formErrorNotification'))
    return
  }

  const request = {
    newEmail: newEmail.value
  } as IChangeEmailRequest
  changeEmailResponse.value = await userService.changeEmail(request)

  changeEmailResponse.value.succeeded
    ? notifySuccess(t('email.form.successMessage'))
    : notifyError(t('email.form.failedMessage'));
  
  let logoutButton = document.getElementById('js-logout-btn') as HTMLElement
  logoutButton.click()
}

</script>
